import { render, staticRenderFns } from "./VersionIndex.vue?vue&type=template&id=1ee45a50&scoped=true&"
import script from "./VersionIndex.vue?vue&type=script&lang=js&"
export * from "./VersionIndex.vue?vue&type=script&lang=js&"
import style0 from "./VersionIndex.vue?vue&type=style&index=0&id=1ee45a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee45a50",
  null
  
)

export default component.exports